import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var SonIAContainer = styled.div.withConfig({
  displayName: "partials__SonIAContainer",
  componentId: "sc-cb06j4-0"
})(["display:flex;justify-content:space-between;align-items:flex-start;padding:20px 40px;border:1px solid #ccc;border-radius:4px;margin-bottom:30px;@media (max-width:900px){padding:20px 20px;}"]);
export var Image = styled.img.withConfig({
  displayName: "partials__Image",
  componentId: "sc-cb06j4-1"
})(["width:100px;height:100px;border-radius:50%;@media (max-width:900px){display:none;}"]);
export var ResponsiveImage = styled.img.withConfig({
  displayName: "partials__ResponsiveImage",
  componentId: "sc-cb06j4-2"
})(["width:70px;height:70px;border-radius:50%;margin-right:20px;@media (min-width:900px){display:none;}"]);
export var CommonContainer = styled.div.withConfig({
  displayName: "partials__CommonContainer",
  componentId: "sc-cb06j4-3"
})(["margin-left:50px;width:100%;@media (max-width:900px){margin-left:20px;margin-right:0;}"]);
export var TextContainer = styled.div.withConfig({
  displayName: "partials__TextContainer",
  componentId: "sc-cb06j4-4"
})(["width:100%;margin:0;"]);
export var TitleContainer = styled.div.withConfig({
  displayName: "partials__TitleContainer",
  componentId: "sc-cb06j4-5"
})(["display:flex;"]);
export var Title = styled.p.withConfig({
  displayName: "partials__Title",
  componentId: "sc-cb06j4-6"
})(["font-weight:bold;font-size:1.2rem;margin:0;margin-bottom:10px;"]);
export var Description = styled.div.withConfig({
  displayName: "partials__Description",
  componentId: "sc-cb06j4-7"
})(["margin:0;p{margin:15px 0;}"]);
export var ButtonsContainer = styled.div.withConfig({
  displayName: "partials__ButtonsContainer",
  componentId: "sc-cb06j4-8"
})(["display:flex;flex-wrap:wrap;"]);
export var Button = styled.button.withConfig({
  displayName: "partials__Button",
  componentId: "sc-cb06j4-9"
})(["cursor:pointer;border-radius:3px;padding:10px 11px;background-color:", ";color:", ";border:1px solid;border-color:", ";margin:0 5px 10px;&:hover{color:", ";background-color:", ";}", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.secondaryButtonFontColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.mainColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.mainColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.secondaryButtonFontColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.mainColor;
}, maxMediaQueries.desktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: 10px 22px;\n  "]))), maxMediaQueries.tablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 100%;\n    margin: 0 0 10px;\n  "]))));
export var SelectedButton = styled(Button).withConfig({
  displayName: "partials__SelectedButton",
  componentId: "sc-cb06j4-10"
})(["color:", ";background-color:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.secondaryButtonFontColor;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.mainColor;
});